import { COLOR } from 'admin/constants/styles';
import React from 'react';
import styled from 'styled-components';
import { fetchSummary } from '../../../actions/transactions';

type Props = {
  summary?: Awaited<ReturnType<typeof fetchSummary>>['summary'];
};

const SummaryWrapper = styled.div`
  display: flex;
  margin: 15px auto;
`;
const SummaryItemWrapper = styled.div`
  display: flex;
  padding: 0.5rem 1rem;
  margin: 0 1rem;
  background: rgba(214, 103, 11, 0.2);
  justify-content: center;
  align-items: center;
  font-weight: 700;
  border-radius: 3px;
`;
const SummaryTotalWrapper = styled(SummaryItemWrapper)`
  background: ${COLOR.lightGray};
`;
const SummaryTopupWrapper = styled(SummaryItemWrapper)`
  background: ${COLOR.lightBlue};
`;
const SummaryPaymentWrapper = styled(SummaryItemWrapper)`
  background: ${COLOR.lightRed};
`;

const Summary = ({ summary }: Props) => {
  if (!summary) {
    return null;
  }
  const total = summary.payment.count + summary.topup.count;
  const topupMoney = summary.topup.money;
  const topupPoint = summary.topup.raw_point;
  const topupTotal = topupMoney + topupPoint;
  const paymentMoney = summary.payment.money;
  const paymentPoint = summary.payment.raw_point;
  const paymentTotal = paymentMoney + paymentPoint;
  return (
    <SummaryWrapper>
      <SummaryTotalWrapper>
        <div>合計 {total}件</div>
      </SummaryTotalWrapper>
      <SummaryTopupWrapper>
        <div>チャージ ¥{topupTotal.toLocaleString()}</div>
      </SummaryTopupWrapper>
      <SummaryPaymentWrapper>
        <div>支払計 ¥{paymentTotal.toLocaleString()}</div>
      </SummaryPaymentWrapper>
    </SummaryWrapper>
  );
};

export default Summary;
